<ng-container *transloco="let t; scope: 'cc';">
    <div class="flex flex-wrap -mt-4 -ml-4">
        <ng-container *ngIf="!selectedCountries || !selectedCountries.length">
            <div
                class="mdc-button mdc-button--unelevated mat-mdc-unelevated-button mat-unthemed mat-mdc-button-base ml-4 mt-4 cursor-auto flex items-center bg-gray-100 dark:bg-gray-700"
                tabindex="1">
                <mat-icon [svgIcon]="'heroicons_outline:globe-alt'" class="mr-2"></mat-icon>
                <span>{{emptyChipLabel}}</span>
            </div>
        </ng-container>

        <ng-container *ngFor="let country of selectedCountries;">
            <div
                class="mdc-button mdc-button--unelevated mat-mdc-unelevated-button mat-unthemed mat-mdc-button-base ml-4 mt-4 cursor-auto flex items-center bg-gray-100 dark:bg-gray-700"
                tabindex="1">
                <div
                    [style.background]="'url(\'/assets/images/flags/flags.png\') ' +utilService.getFlagPositionForCountry(country) + ' / 24px 3876px no-repeat'"
                    class="flex w-6 h-4 overflow-hidden mr-2"></div>
                <span class="border-r border-gray-300 pr-3">{{t('cc.' + country.alpha2)}}</span>
                <mat-icon *ngIf="!disabled" (click)="removeCountry(country)" [svgIcon]="'heroicons_outline:x-mark'" class="ml-3 cursor-pointer"></mat-icon>
            </div>
        </ng-container>

        <button
            *ngIf="!disabled"
            (click)="stopPropagation($event); searchForm.get('countries').setValue('');"
            [matMenuTriggerFor]="countriesMenu"
            class="ml-4 mt-4"
            color="primary"
            mat-flat-button
            tabindex="1"
            type="button">
            <mat-icon [svgIcon]="'heroicons_outline:plus'" class="mx-2"></mat-icon>
        </button>

        <form [formGroup]="searchForm">
            <mat-menu #countriesMenu="matMenu">
                <ng-template matMenuContent>
                    <mat-form-field (click)="stopPropagation($event)" class="w-full px-4 fuse-mat-no-subscript">
                        <input autocomplete="off" autofocus formControlName="countries" matInput maxlength="256" [placeholder]="'search-placeholder' | transloco">
                        <button (click)="stopPropagation($event); searchForm.get('countries').setValue('');" [ngClass]="{'opacity-0': !searchForm.get('countries').value}"
                                aria-label="Clear" class="opacity-1 transition-opacity duration-150" mat-icon-button matSuffix>
                            <mat-icon>close</mat-icon>
                        </button>
                    </mat-form-field>
                    <ng-container *ngFor="let country of filteredCountries; trackBy: trackByFn">
                        <button (click)="addCountry(country)" class="mat-mdc-menu-item">
                            <div
                                [style.background]="'url(\'/assets/images/flags/flags.png\') ' +utilService.getFlagPositionForCountry(country) + ' / 24px 3876px no-repeat'"
                                class="min-w-6 w-6 h-4 overflow-hidden mr-2"></div>
                            {{t("cc." + country.alpha2)}}
                        </button>
                    </ng-container>
                </ng-template>
            </mat-menu>

        </form>
    </div>
</ng-container>
